/* My Acre chosen-value label re-sync (2026-08-11, Claude).

   The picker in snippets/product-options.liquid writes each option's chosen value
   from the change event's own target, so it only ever updates the option the shopper
   actually clicked. That is wrong whenever the theme changes a DIFFERENT option for
   them: pick Serenity's 2.5m Square, which is not made with a Heron Black frame, and
   the frame silently falls back to Space Grey while the label still reads "Heron
   Black". The recap and price were right, so the label was the only thing lying.

   This re-reads every option's checked radio after any change inside the picker and
   rewrites all the labels, so what is written always matches what is selected.
   Site-wide and idempotent; it only ever writes text that is already true. */
(function () {
  function syncAll(container) {
    if (!container) return;
    var labels = container.querySelectorAll('[data-selected-option]');
    for (var i = 0; i < labels.length; i++) {
      var index = labels[i].getAttribute('data-selected-option');
      var checked = container.querySelector('.ma-option-value__input[data-product-option="' + index + '"]:checked');
      var next = checked ? checked.value : '';
      if (labels[i].textContent.trim() !== next) labels[i].textContent = next;
    }
  }

  function bind(container) {
    if (!container || container.dataset.maLabelSyncBound) return;
    container.dataset.maLabelSyncBound = '1';
    container.addEventListener('change', function () {
      /* Let the theme finish resolving the variant (it can move other options) before
         reading back what is actually checked. */
      setTimeout(function () { syncAll(container); }, 0);
      setTimeout(function () { syncAll(container); }, 250);
    });
    syncAll(container);
  }

  function boot() {
    document.querySelectorAll('[data-product-options-container]').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
